<template>
    <div class="row">
        <div class="col-4">
            <div class="card with-padding card--viridian-green essential-business-scheme" v-if="essentialBusinessScheme">
                <h3>{{ product.name }}
                    <VDropdown :disabled="!tooltip">
                        <button class="tooltip-button"><i class="icon-info-solid"/></button>
                        <template #popper>
                            <p>For more information, please refer to the scheme Handbook or FAQs.</p>
                        </template>
                    </VDropdown>
                </h3>
                <p>All vehicles under this scheme are provided under a Credit Sale Agreement.</p>
                <ul>
                    <li v-if="essentialBusinessScheme.grade" class="grade-name"><span
                        class="key">Grade Name</span><span class="value">{{ essentialBusinessScheme.grade }}</span>
                    </li>
                    <li v-if="essentialBusinessScheme.fuelReimbursement" class="fuel-reimbursements">
                                <span class="key">
                                    Fuel Reimbursements
                                    <VDropdown :disabled="!tooltip">
                                        <button class="tooltip-button"><i class="icon-info-solid"/></button>
                                        <template #popper>
                                            <p>This value is [From HRUX – TBC]</p>
                                        </template>
                                    </VDropdown>
                                </span>
                        <span class="value">£{{ essentialBusinessScheme.fuelReimbursement }}</span></li>
                    <li v-if="essentialBusinessScheme.netCash" class="net-cash">
                                <span class="key">
                                    Gross Cash
                                    <VDropdown :disabled="!tooltip">
                                        <button class="tooltip-button"><i class="icon-info-solid"/></button>
                                        <template #popper>
                                            <p>This value is [From HRUX – TBC]</p>
                                        </template>
                                    </VDropdown>
                                </span>
                        <span class="value">£{{ essentialBusinessScheme.netCash }}</span>
                    </li>
                    <li v-if="essentialBusinessScheme.total" class="total-relevant-motoring-amounts">
                            <span class="key">Total Relevant Motoring Amounts
                                <VDropdown :disabled="!tooltip">
                                    <button class="tooltip-button"><i class="icon-info-solid"/></button>
                                    <template #popper>
                                        <p>This value is [From HRUX – TBC]</p>
                                    </template>
                                </VDropdown>
                            </span>
                        <span class="value">£{{ essentialBusinessScheme.total }}</span></li>
                </ul>
            </div>
        </div>
        <div class="col-4">
            <div class="card with-padding card--raisin-black company-car" v-if="companyCarScheme">
                <h3>Company Car</h3>
                <ul>
                    <li v-if="companyCarScheme.grade" class="grade-name"><span class="key">Grade Name</span><span
                        class="value">{{ companyCarScheme.grade }}</span>
                    </li>
                    <li v-if="companyCarScheme.fuelReimbursement" class="fuel-reimbursements">
                                <span class="key">
                                    Fuel Reimbursements
                                    <VDropdown :disabled="!tooltip">
                                        <button class="tooltip-button"><i class="icon-info-solid"/></button>
                                        <template #popper>
                                            <p>This value is [From HRUX – TBC]</p>
                                        </template>
                                    </VDropdown>
                                </span>
                        <span class="value">£{{ companyCarScheme.fuelReimbursement }}</span>
                    </li>
                    <li v-if="companyCarScheme.netCash" class="net-cash">
                                <span class="key">
                                    Net Cash
                                    <VDropdown :disabled="!tooltip">
                                            <button class="tooltip-button"><i class="icon-info-solid"/></button>
                                            <template #popper>
                                                <p>This value is [From HRUX – TBC]</p>
                                            </template>
                                    </VDropdown>
                                </span>
                        <span class="value">£{{ companyCarScheme.netCash }}</span>
                    </li>
                    <li class="total">
                            <span class="key">Total
                                 <VDropdown :disabled="!tooltip">
                                    <button class="tooltip-button"><i class="icon-info-solid"/></button>
                                    <template #popper>
                                        <p>This value is [From HRUX – TBC]</p>
                                    </template>
                                </VDropdown>
                            </span>
                        <span class="value">£{{ companyCarScheme.total }}</span>
                    </li>
                </ul>
            </div>
        </div>

    </div>

</template>

<script>

export default {
    name: 'ecoamaps-your-profile-scheme-details-component',

    props: [
        'profile',
        'companyCarScheme',
        'essentialBusinessScheme',
        'product',
        'scheme',
        'schemeId',
        'tooltip',
    ],
}
</script>

